import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M11.664 6.93c0 .842.024.457.048 3.052.072 5.958-3.508 5.453-3.003 3.075.528-2.426 8.168-1.105 8.168-1.105"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M20 11.928c0 4.42-3.58 8-8 8s-8-3.556-8-7.976a8 8 0 0 1 4.5-7.197"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M12.961 4c1.898.216 3.7 1.13 5.069 2.667.36.408.649.816.913 1.273"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M20 6.956c-.146.714-.585 2-.585 2S18.098 8.742 17 8.313"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const BackTimeIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
